import cn from 'classnames'
import React from 'react'

import styles from './List.module.scss'

import Text from '~shared/ui/Text'

interface ListItemProps extends React.LiHTMLAttributes<HTMLLIElement> {
  children?: React.ReactNode
}

export function ListItem({ children, ...props }: ListItemProps) {
  return <li {...props}>{children}</li>
}

type ListStyleType = 'disc' | 'circle' | 'square' | 'decimal' | 'georgian'
type ListType = keyof Pick<JSX.IntrinsicElements, 'ol' | 'ul'>

interface ListProps extends React.HTMLAttributes<HTMLElement> {
  as?: ListType
  type?: ListStyleType
  variant?: 'default' | 'secondary'
  children?: React.ReactNode
}

export function List({ as = 'ul', type, variant = 'default', children, className, ...props }: ListProps) {
  return (
    <Text as={as} variant={variant} className={cn(styles[type], className)} {...props}>
      {children}
    </Text>
  )
}
